import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faBluesky,
  faYoutube,
  faLinkedin,
  faFacebookSquare,
  faSoundcloud,
} from '@fortawesome/free-brands-svg-icons';
import {
  faArrowUpRightFromSquare,
  faGavel,
  faUserSecret,
  faCopyright,
  faTerminal,
  faSearch,
  faEnvelope,
  faPaperPlane,
  faLock,
  faClock,
  faHourglassEnd,
  faAngleUp,
  faAngleLeft,
  faAngleRight,
  faBookmark,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileVideo,
  faFilePowerpoint,
  faFileImage,
  faFileAudio,
  faFile,
  faFileLines,
} from '@fortawesome/free-regular-svg-icons';

export function initIcons() {
  library.add(
    faBluesky,
    faYoutube,
    faLinkedin,
    faFacebookSquare,
    faSoundcloud,
    faArrowUpRightFromSquare,
    faGavel,
    faUserSecret,
    faCopyright,
    faTerminal,
    faSearch,
    faEnvelope,
    faPaperPlane,
    faLock,
    faClock,
    faHourglassEnd,
    faFilePdf,
    faFileWord,
    faFileExcel,
    faFileVideo,
    faFilePowerpoint,
    faFileImage,
    faFileAudio,
    faFile,
    faFileLines,
    faAngleUp,
    faAngleLeft,
    faAngleRight,
    faBookmark,
  );

  dom.watch();
}

export default initIcons;
